"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("../axios.js"));

var _ampConfig = _interopRequireDefault(require("../amp-config.js"));

var _errors = require("../errors.js");

var _contentCache = _interopRequireDefault(require("../content-cache.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var fetchUnit = function fetchUnit(unitKey, revision) {
  var flatten = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var params = {};

  if (revision) {
    params['revision'] = revision;
  }

  if (flatten) {
    params['flatten'] = flatten;
  }

  var cache = _contentCache["default"].get(unitKey, revision, flatten);

  if (cache.promise !== undefined) {
    return cache.promise;
  }

  return _ampConfig["default"].get('cds').then(function (cdsUrl) {
    if (!cdsUrl) {
      return Promise.reject((0, _errors.missingConfig)('cds'));
    } // if _es unit does not exist (i.e., for ELA units), we will have already caught when
    // fetching its revision and set the cached revision for the non-_es unitKey


    var cachedRevisionForUnit = cachedRevisions.find(function (revisionData) {
      return revisionData.businessKey === unitKey;
    });

    if (!cachedRevisionForUnit) {
      var enUnitKey = unitKey.replace('_es', '');
      var cachedRevisionForEnUnit = cachedRevisions.find(function (_ref) {
        var businessKey = _ref.businessKey;
        return businessKey === enUnitKey;
      });

      if (cachedRevisionForEnUnit) {
        unitKey = enUnitKey;
      }
    }

    var promise = _axios["default"].get("".concat(cdsUrl, "/api/unit/").concat(unitKey), {
      params: params
    });

    _contentCache["default"].set(unitKey, revision, flatten, promise);

    return promise.then(function (data) {
      _contentCache["default"].remove(unitKey, revision, flatten);

      return data;
    });
  });
};

var fetchOverview = function fetchOverview(unitRevisionStrings) {
  var params = {
    units: unitRevisionStrings
  };
  return _ampConfig["default"].get('cds').then(function (cdsUrl) {
    if (!cdsUrl) {
      return Promise.reject((0, _errors.missingConfig)('cds'));
    }

    return _axios["default"].get("".concat(cdsUrl, "/api/yearoverview"), {
      params: params
    });
  });
};

var cachedRevisions = [];

var fetchUnitRevision = function fetchUnitRevision(unitKey, unitRevision) {
  if (unitRevision === undefined) {
    return Promise.reject('Cannot fetch revision for undefined alias');
  }

  if (_lodash["default"].isNumber(unitRevision) || _lodash["default"].isString(unitRevision) && unitRevision.match(/^[0-9]+$/)) {
    return Promise.resolve({
      data: unitRevision
    });
  } else {
    // check to see if current revisionAlias exists in the cache and fetching actual revision
    var foundInCache = _lodash["default"].find(cachedRevisions, function (item) {
      return item.businessKey === unitKey && item.revisionAlias === unitRevision;
    });

    if (foundInCache) {
      return Promise.resolve({
        data: foundInCache.revision
      });
    } else if (unitKey.endsWith('_es')) {
      // the Spanish revision will be the same as the English revision; don't re-fetch if we already have it
      var foundEnVersionInCache = _lodash["default"].find(cachedRevisions, function (item) {
        return unitKey.startsWith(item.businessKey) && item.revisionAlias === unitRevision;
      });

      if (foundEnVersionInCache) {
        cachedRevisions.push({
          businessKey: unitKey,
          revisionAlias: unitRevision,
          revision: foundEnVersionInCache.revision
        });
        return Promise.resolve({
          data: foundEnVersionInCache.revision
        });
      }
    }
  }

  return _ampConfig["default"].get('cds').then(function (cdsUrl) {
    if (!cdsUrl) {
      return Promise.reject((0, _errors.missingConfig)('cds'));
    }

    var getUrl = function getUrl() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : unitKey;
      var revision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : unitRevision;
      return "".concat(cdsUrl, "/api/alias/resolve/").concat(key, "/").concat(revision);
    };

    var handleResponse = function handleResponse(response, unitKey) {
      cachedRevisions.push({
        businessKey: unitKey,
        revisionAlias: unitRevision,
        revision: response.data
      });
      return response;
    };

    return _axios["default"].get(getUrl()).then(function (response) {
      return handleResponse(response, unitKey);
    })["catch"](function (error) {
      var statusCode = error.response.status;

      if (statusCode === 404 && unitKey.endsWith('_es')) {
        unitKey = unitKey.replace('_es', '');
        return _axios["default"].get(getUrl(unitKey)).then(function (response) {
          return handleResponse(response, unitKey);
        });
      } else {
        return {
          data: unitRevision
        };
      }
    });
  });
};

var fetchCardstacksForUnit = function fetchCardstacksForUnit(unitKey, revision) {
  var cardstackKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (_lodash["default"].isString(cardstackKeys)) {
    cardstackKeys = [cardstackKeys];
  }

  return _ampConfig["default"].get('cds').then(function (cdsUrl) {
    if (!cdsUrl) {
      return Promise.reject((0, _errors.missingConfig)('cds'));
    }

    return _axios["default"].get("".concat(cdsUrl, "/api/unit/").concat(unitKey, ":").concat(revision, "/cardstack")).then(function (response) {
      if (cardstackKeys.length > 0) {
        return _lodash["default"].filter(response.data, function (cardstack) {
          return cardstackKeys.includes(cardstack.businessKey);
        });
      } else {
        return response.data;
      }
    });
  });
};

var checkUnitKeysAreValid = function checkUnitKeysAreValid() {
  var unitKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (_lodash["default"].isString(unitKeys)) {
    unitKeys = [unitKeys];
  }

  return _ampConfig["default"].get('cds').then(function (cdsUrl) {
    if (!cdsUrl) {
      return Promise.reject((0, _errors.missingConfig)('cds'));
    }

    return Promise.all(unitKeys.map(function (unitKeyWithOptionalRevision) {
      var _unitKeyWithOptionalR = unitKeyWithOptionalRevision.split(/:|#/),
          _unitKeyWithOptionalR2 = _slicedToArray(_unitKeyWithOptionalR, 2),
          unitKey = _unitKeyWithOptionalR2[0],
          revision = _unitKeyWithOptionalR2[1];

      return fetchUnitRevision(unitKey, revision).then(function (response) {
        return _axios["default"].get("".concat(cdsUrl, "/api/alias/confirm/").concat(unitKey, "/").concat(response.data)).then(function (res) {
          return res.data;
        });
      });
    }));
  });
};

var fetchUnitRevisionAliases = function fetchUnitRevisionAliases(unitKey, unitRevision) {
  return _ampConfig["default"].get('cds').then(function (cdsUrl) {
    if (!cdsUrl) {
      return Promise.reject((0, _errors.missingConfig)('cds'));
    }

    return _axios["default"].get("".concat(cdsUrl, "/api/alias/aliases/").concat(unitKey, "/").concat(unitRevision)).then(function (res) {
      return res.data;
    });
  });
};

var _default = {
  fetchUnit: fetchUnit,
  fetchOverview: fetchOverview,
  fetchCardstacksForUnit: fetchCardstacksForUnit,
  fetchUnitRevision: fetchUnitRevision,
  fetchUnitRevisionAliases: fetchUnitRevisionAliases,
  checkUnitKeysAreValid: checkUnitKeysAreValid
};
exports["default"] = _default;